<template>
  <div class="language-selector">
    <div class="selected-language" @click="toggleDropdown">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 6.99992V6.99642C14 4.925 13.0982 3.06475 11.6661 1.7855L11.6591 1.77967C11.6414 1.76061 11.6216 1.74359 11.6002 1.72892L11.599 1.72833C10.327 0.6117 8.69141 -0.00263713 6.99884 0.000500239C5.23017 0.000500239 3.6155 0.657333 2.38467 1.74117L2.39225 1.73475C2.37746 1.74606 2.36379 1.75875 2.35142 1.77267C1.61151 2.42789 1.01925 3.23342 0.61387 4.13478C0.208494 5.03614 -0.000748641 6.01334 2.01258e-06 7.00167C2.01258e-06 9.0725 0.900669 10.9327 2.33159 12.2126L2.33859 12.2184C2.3572 12.2393 2.37792 12.2583 2.40042 12.275L2.40159 12.2756C3.67316 13.3907 5.30757 14.0042 6.99884 14.0011C8.69801 14.0037 10.3394 13.3846 11.6136 12.2604L11.606 12.2668C12.3588 11.6124 12.9622 10.8038 13.3754 9.89598C13.7886 8.98811 14.002 8.00207 14.0012 7.00458V7.0005L14 6.99992ZM11.3972 11.5528C11.0503 11.2725 10.6774 11.026 10.2836 10.8167L10.2457 10.798C10.6033 9.76725 10.8185 8.579 10.8389 7.34292V7.33358H13.3245C13.2409 8.93279 12.5526 10.4404 11.3989 11.5511L11.3972 11.5528ZM7.33367 10.6749C8.08209 10.7152 8.7815 10.8797 9.42667 11.1474L9.38467 11.1322C8.86784 12.3106 8.14042 13.1203 7.33367 13.2982V10.6749ZM7.33367 10.0076V7.33358H10.1733C10.1507 8.4409 9.95874 9.53822 9.604 10.5874L9.62675 10.511C8.90265 10.2129 8.1323 10.0428 7.35 10.0082L7.33367 10.0076ZM7.33367 6.66625V3.99225C8.13703 3.9557 8.92794 3.77984 9.67109 3.4725L9.625 3.48942C9.94875 4.43383 10.1477 5.52233 10.1733 6.654V6.66625H7.33367ZM7.33367 3.32492V0.702834C8.14042 0.88075 8.86784 1.68692 9.38467 2.86875C8.7815 3.11958 8.08209 3.2835 7.35059 3.32433L7.33367 3.32492ZM8.9985 0.991584C9.68606 1.22041 10.329 1.56615 10.899 2.01358L10.8856 2.00308C10.6272 2.20608 10.3373 2.39742 10.0316 2.56367L9.99892 2.58C9.75256 1.99676 9.4129 1.45751 8.99325 0.983417L8.9985 0.989834V0.991584ZM6.66517 0.704584V3.32492C5.94562 3.28826 5.23768 3.12844 4.57217 2.85242L4.61417 2.86758C5.13334 1.68925 5.85959 0.880167 6.66634 0.70225L6.66517 0.704584ZM4.0005 2.57825C3.68437 2.40799 3.38309 2.21149 3.09984 1.99083L3.11384 2.00133C3.66723 1.56701 4.29006 1.22937 4.956 1.00267L5.00034 0.98925C4.59209 1.4508 4.25955 1.97412 4.01509 2.53975L4.0005 2.57825ZM6.66634 3.99167V6.66567H3.82667C3.85234 5.52175 4.05125 4.43325 4.39775 3.41242L4.375 3.48883C5.09913 3.78547 5.86887 3.95536 6.65059 3.99108L6.66634 3.99167ZM6.66634 7.333V10.007C5.86297 10.0435 5.07207 10.2194 4.32892 10.5267L4.375 10.5098C4.05125 9.566 3.85234 8.47692 3.82667 7.34525V7.333H6.66634ZM6.66634 10.6743V13.2964C5.85959 13.1185 5.13217 12.3123 4.61534 11.1305C5.2185 10.8797 5.91792 10.7163 6.64942 10.6755L6.66634 10.6743ZM5.00384 13.0077C4.31689 12.7785 3.67415 12.4336 3.10334 11.988L3.11734 11.9985C3.37575 11.7955 3.66567 11.6042 3.97134 11.4379L4.004 11.4216C4.24852 12.0049 4.58817 12.5437 5.00909 13.0158L5.00384 13.01V13.0077ZM9.9995 11.421C10.3378 11.6047 10.6278 11.7955 10.9002 12.0084L10.8862 11.9979C10.3328 12.4322 9.70995 12.7699 9.044 12.9966L8.99967 13.01C9.40787 12.5486 9.7404 12.0255 9.98492 11.4601L9.9995 11.4222V11.421ZM13.3245 6.66625H10.8389C10.8207 5.45934 10.6124 4.26284 10.2218 3.12075L10.2457 3.20125C10.6577 2.98423 11.0478 2.72793 11.4106 2.43592L11.3966 2.44642C12.5483 3.55257 13.237 5.0548 13.3233 6.64933L13.3245 6.66625ZM2.60284 2.447C2.93884 2.72 3.31625 2.97025 3.71642 3.18317L3.75434 3.20183C3.39675 4.23258 3.1815 5.42083 3.16109 6.65692V6.66625H0.674919C0.758508 5.06704 1.44685 3.5594 2.6005 2.44875L2.60284 2.447ZM0.675502 7.33358H3.16109C3.17933 8.54049 3.3876 9.737 3.77825 10.8791L3.75434 10.7986C3.31625 11.0313 2.93942 11.2816 2.58942 11.5639L2.60342 11.5534C1.45172 10.4473 0.763049 8.94503 0.676669 7.3505L0.675502 7.33358Z" fill="#3749C0"/>
      </svg>
      <p>{{ getFullLanguageName(activeLanguage) }}</p>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 7L8.00001 11L12 7" stroke="#3749C0" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <transition name="fast-fade">
      <div class="language-dropdown" v-if="isDropdownOpen">
        <div v-for="locale in availableLanguages"
             :key="locale"
             :class="['language-option', { active: locale === activeLanguage }]"
             @click="changeLocale(locale)">
          {{ getFullLanguageName(locale) }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    activeLanguage: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      isDropdownOpen: false,
      myLangOrder: ["UA", "RU", "EN", "DE"],
      languageNames: {
        UA: 'Ukrainian',
        RU: 'Russian',
        EN: 'English',
        DE: 'German',
        ES: 'Spanish',
        PT: 'Portuguese',
        PL: 'Polish'
      }
    };
  },
  computed: {
    availableLanguages() {
      let languages = this.$i18n.availableLocales.filter((locale) => locale !== this.activeLanguage);
      languages.sort((a, b) => {
        const aIndex = this.myLangOrder.indexOf(a);
        const bIndex = this.myLangOrder.indexOf(b);
        return aIndex - bIndex;
      });
      return [this.activeLanguage, ...languages];
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    changeLocale(locale) {
      // this.$i18n.locale = locale;
      this.isDropdownOpen = false;
      this.$emit('change-locale', locale);
    },
    getFullLanguageName(locale) {
      return this.languageNames[locale] || locale;
    }
  },
};
</script>

<style scoped>
.language-selector {
  position: relative;
  display: inline-block;
}

.selected-language {
  padding: 5px 8px 5px 8px;
  border-bottom: 1px solid #3749C0;
  color: #3749C0;
  font-size: 14px;
  min-width: 120px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.selected-language:hover {
  background-color: #EFF1FF;
}

.selected-language svg {
  margin-left: 4px;
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.language-dropdown {
  width: 100%;
  position: absolute;
  color: #3749C0;
  top: 0;
  left: 0;
  display: none;
  background-color: #fff;
  padding: 0;
  border: none;
  box-shadow: 0 1px 4px rgba(28, 28, 28, .08);
  border-radius: 8px;
  z-index: 1000;
}

.language-selector:hover .language-dropdown {
  display: block;
  overflow: hidden;
}

.language-option {
  padding: 8px 28px 8px 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}

.language-option:hover {
  background-color: #EFF1FF;
  color: #3749C0;
}

.language-option:first-child,
.language-option:first-child:hover {
  color: #808080;
}

.language-option.active {
  font-weight: 400;
}
</style>
